import { SWRConfig, useSWRConfig } from 'swr';
import { useRouter } from 'next/router';
import mixpanel from 'mixpanel-browser';

//ApiEndpoints
import { USER, USER_SOCIAL_PROFILES } from '@/lib/routes/apiEndpoints';

//Routes
import { SIGN_IN } from '@/routes/publicRoutes';
import { DOWNGRADE_FUNNEL, DOWNGRADE_FUNNEL_BLOCKED } from '@/routes/privateRoutes';

//Hooks
import useUserRole from '@/hooks/user/useUserRole';

const SWRConfigWrapper = ({ children }) => {
    const router = useRouter();
    const { isAdmin } = useUserRole();
    const { mutate } = useSWRConfig();

    return (
        <SWRConfig
            value={{
                onError: (error, key) => {
                    const isUnAuthenticated =
                        error.response?.status === 401 &&
                        error.response?.data?.subcode === 'auth_unauthenticated';

                    const cantFetchUserAndSocialProfiles =
                        (key === USER || key === USER_SOCIAL_PROFILES) &&
                        error.response?.status === 500;

                    if (isUnAuthenticated || cantFetchUserAndSocialProfiles) {
                        //Redirect user to signin if 401 return from api
                        mutate(USER, false);
                        //reset mixpanel user
                        mixpanel.reset();
                        router.push(SIGN_IN);
                        return;
                    }

                    //if 403 and info message is "Subscription over consumption." => Redirect user to downgrade flow
                    const isOverConsumption =
                        error.response?.status === 403 &&
                        error.response?.data?.subcode === 'subscription_over_consumption';

                    if (isOverConsumption) {
                        if (isAdmin) {
                            router.push(DOWNGRADE_FUNNEL);
                            return;
                        }

                        router.push(DOWNGRADE_FUNNEL_BLOCKED);
                    }
                }
            }}>
            {children}
        </SWRConfig>
    );
};

export default SWRConfigWrapper;
